

import React, { Component } from 'react'
import styled from 'styled-components'
import { Ptag, Input, LargeButton } from '.'

import { Formik, Form } from "formik";
import * as Yup from "yup";
import http from "../../services/httpService";

export default class AddManually extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount = async () => {

    try {
      const { data } = await http.post("/users/user/");
      let apidata = [];

      this.setState({ apidata, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  };


  handleChange = (event, setFieldValue, name, length) => {
    const value = event.target.value;
    setFieldValue(name, value.slice(0, length));
  };

  renderInput = ({
    name,
    placeholder,
    type,
    formikProps,
    length = 70,
  } = {}) => {
    const { errors, touched, handleBlur, setFieldValue, values } = formikProps;
    const error = touched[name] && errors[name];
    return (
      <InputContainer>
        <Input
          value={values[name]}
          name={name}
          placeholder={placeholder}
          type={type}
          error={error}
          onChange={(event) =>
            this.handleChange(event, setFieldValue, name, length)
          }
          onBlur={handleBlur}
        />
      </InputContainer>
    );
  };


  handleSubmit = async (values) => {
    this.setState({ loading: true });
    console.log(values, 'gajendra')
    this.setState({})
  };

  buildyourplan = () => {
    this.props.history.push("/buildyourplan");
  }

  renderForm = (formikProps) => {
    const isDisabled =
      formikProps &&
      formikProps.values &&
      Object.values(formikProps.values).filter((item) => !item).length > 0;

    return (
      <HomeWrapper>

        <Ptag
          fontSize="24px"
          fontWeight="500"
          letterHeight="1.33"
          letterSpacing="0.35px"
        >
          {"Enter Employee Details"}
        </Ptag>
        <Form>
          {this.renderInput({
            name: "name",
            placeholder: "Name",
            type: "text",
            formikProps,
          })}

          {this.renderInput({
            name: "number",
            placeholder: "Mobile Number",
            type: "text",
            formikProps,
          })}




          {this.renderInput({
            name: "email",
            placeholder: "Email",
            type: "text",
            formikProps,
          })}


          <ButtonWrapper>
            <LargeButton
              onClick={this.buildyourplan}
              disabled={isDisabled}
              opacity={isDisabled ? "0.4" : "1"}

              id=""
              label="Next"
              type="submit"
            />
          </ButtonWrapper>
        </Form>
      </HomeWrapper>
    );
  };




  render() {

    const Schema = Yup.object().shape({
      name: Yup.string().required("*Required"),
      number: Yup.string().required("*Required"),
      email: Yup.string().email().required("*Required"),
    });
    const initialValues = {
      name: "",
      mobile: "",
      email: "",
    };
    return (

      <Body>



        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={Schema}
          onSubmit={this.handleSubmit}
          render={(formikProps) => this.renderForm(formikProps)}
        />

      </Body>
    );
  }
}


const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px 24px;
  flex: 1;
`;

const InputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  margin-top:60px
`;

const HomeWrapper = styled.div`
  margin-left: 252px;
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  
`




